import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f7f7f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: '40px 20px',
      textAlign: 'center',
    }}>
      <p style={{ fontSize: '4rem', marginBottom: '8px' }}>📖</p>
      <h1 style={{
        fontFamily: 'Georgia, serif',
        fontSize: '28px',
        fontWeight: '400',
        color: '#2d346c',
        margin: '0 0 12px',
      }}>
        This page doesn't exist
      </h1>
      <p style={{
        fontSize: '15px',
        color: '#888',
        maxWidth: '320px',
        lineHeight: '1.6',
        margin: '0 0 32px',
      }}>
        The page you're looking for may have moved or never existed.
      </p>
      <Link to="/" style={{
        display: 'inline-block',
        padding: '12px 28px',
        background: '#2d346c',
        color: '#fff',
        borderRadius: '999px',
        fontSize: '14px',
        fontWeight: '600',
        textDecoration: 'none',
      }}>
        Back to home →
      </Link>
    </div>
  );
}

export default NotFound;